import styled from 'styled-components';

const SharedReportWrapper = styled.div`
  opacity: 1;
  transition: opacity 200ms ease-in;
`;

export { SharedReportWrapper };
